import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "search-input" }
const _hoisted_3 = {
  key: 0,
  class: "recently"
}
const _hoisted_4 = { class: "recently-title" }
const _hoisted_5 = { class: "list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "collect" }
const _hoisted_8 = { class: "menu-title" }
const _hoisted_9 = {
  key: 1,
  class: "list collect-list"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "menu-list" }
const _hoisted_12 = {
  key: 0,
  style: {"display":"flex","flex-direction":"row","flex-wrap":"nowrap","height":"100%"}
}
const _hoisted_13 = {
  key: 1,
  class: "all-menu-list"
}
const _hoisted_14 = { class: "menu-title" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["title"]
const _hoisted_17 = ["onClick"]


import { ref, computed, inject } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

import { Search } from '@element-plus/icons-vue'

// import { getUserMenuList } from '@/services/user'
import { t } from 'element-plus/lib/locale'

const __default__ = {
  name: 'Home'
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const $t: any = inject('$t')

const store = useStore()
const router = useRouter()

const searchMenu = ref('')
const allList = ref<any[]>([])
const allMenuList = ref<any[]>([])

const collectLocal = localStorage.getItem('collectMenu')
const collectList = ref(collectLocal ? JSON.parse(collectLocal) : [])

const recentVisitList = computed(() => {
  return store.state.menu.recentVisitList
})

const parseLang = (list: any[]) => {
  const collectMenu = collectLocal ? JSON.parse(collectLocal) : []

  return list.map(item => {
    return {
      ...item,
      menuList: flatMenu([], item.childMenuList ?? []).map((menu: any) => {
        const isHasCollect = collectMenu.some((localMenu: any) => menu.menuId === localMenu.menuId)

        return {
          ...menu,
          collect: isHasCollect
        }
      })
    }
  })
}

const flatMenu = (arr: any[], menus: any[]) => {
  menus.forEach((item: any) => {
    if (item.menuRouteUrl) {
      arr.push(item)
    }
    if (item.childMenuList?.length) {
      flatMenu(arr, item.childMenuList)
    }
  })
  return arr
}

const collectMenuLoading = ref(false)
const getList = async () => {
  try {
    collectMenuLoading.value = true
    //  const {
    //   data: { menuList = [] }
    // } = await getUserMenuList()
    // 直接从 store 中获取菜单数据
    const menuList = store.state.menu.menuList || []
    allMenuList.value = parseLang(menuList)
    allList.value = allMenuList.value
  } catch (error) {
    console.log(error)
  } finally {
    collectMenuLoading.value = false
  }
}
getList()

const handleSearchMenu = (val: string) => {
  if (val === '') {
    allMenuList.value = allList.value
    return
  }
  const list: any[] = []
  allList.value.forEach(item => {
    const hasMenuList = item.menuList.filter((menu: any) => {
      const text = $t(menu.localKey) || menu.menuName
      return text.toLowerCase().indexOf(val.toLowerCase()) !== -1
    })
    if (hasMenuList.length > 0) {
      list.push({
        ...item,
        menuList: hasMenuList
      })
    }
  })
  allMenuList.value = list
}

const toPage = (route: string) => {
  route && router.push(route)
}

const addLocal = (item: any) => {
  const collectMenu = localStorage.getItem('collectMenu')
  const newCollectMenu = collectMenu ? JSON.parse(collectMenu).concat([item]) : [item]
  localStorage.setItem('collectMenu', JSON.stringify(newCollectMenu))
  return newCollectMenu
}

const removeLocal = (item: any) => {
  const collectMenu = JSON.parse(localStorage.getItem('collectMenu') as string)
  const findIndex = collectMenu.findIndex((i: any) => i.menuId === item.menuId)
  collectMenu.splice(findIndex, 1)
  localStorage.setItem('collectMenu', JSON.stringify(collectMenu))
  return collectMenu
}

const handleCollect = async (subItem: any) => {
  try {
    const { menuId, menuName, menuRouteUrl, localKey } = subItem
    const item = { menuId, menuName, menuRouteUrl, localKey: localKey ?? menuName }

    if (subItem.collect) {
      // 取消收藏
      collectList.value = removeLocal(item)
    } else {
      // 收藏
      collectList.value = addLocal(item)
    }

    subItem.collect = !subItem.collect
  } catch (error) {
    console.log(error)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, {
    shadow: "never",
    style: {"height":"100%","box-sizing":"border-box"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_input, {
            clearable: "",
            modelValue: searchMenu.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchMenu).value = $event)),
            placeholder: _unref($t)('main_header_placeholder'),
            onInput: handleSearchMenu
          }, {
            suffix: _withCtx(() => [
              _createVNode(_component_el_icon, {
                class: "el-input__icon",
                size: 16
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Search))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]),
        (recentVisitList.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref($t)('main_header_recent_visit')) + "：", 1),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recentVisitList.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "menu-item",
                    key: item.routeUrl,
                    onClick: ($event: any) => (toPage(item.routeUrl))
                  }, _toDisplayString(_unref($t)(item.localKey) || item.name), 9, _hoisted_6))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref($t)('main_collection_function')), 1),
          (collectMenuLoading.value)
            ? (_openBlock(), _createBlock(_component_el_skeleton, {
                key: 0,
                class: "collect-list",
                animated: ""
              }, {
                template: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                    return _createVNode(_component_el_skeleton_item, {
                      key: i,
                      class: "skeleton"
                    })
                  }), 64))
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collectList.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "menu-item",
                    key: item.menuRouteUrl,
                    onClick: ($event: any) => (toPage(item.menuRouteUrl))
                  }, _toDisplayString(_unref($t)(item.localKey) || item.menuName), 9, _hoisted_10))
                }), 128))
              ]))
        ]),
        _createElementVNode("div", _hoisted_11, [
          (collectMenuLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                  return _createVNode(_component_el_skeleton, {
                    animated: "",
                    key: i,
                    class: "skeleton-column"
                  }, {
                    template: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (i) => {
                        return _createVNode(_component_el_skeleton_item, {
                          key: i,
                          class: "skeleton"
                        })
                      }), 64))
                    ]),
                    _: 2
                  }, 1024)
                }), 64))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allMenuList.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.menuId,
                    class: "item"
                  }, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_unref($t)(item.localKey) || item.menuName), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.menuList, (subItem) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: subItem.menuId
                      }, [
                        (subItem.menuRouteUrl)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "menu-item",
                              onClick: ($event: any) => (toPage(subItem.menuRouteUrl))
                            }, [
                              _createElementVNode("div", {
                                class: "menu-item-span",
                                title: _unref($t)(subItem.localKey) || subItem.menuName
                              }, _toDisplayString(_unref($t)(subItem.localKey) || subItem.menuName), 9, _hoisted_16),
                              _createElementVNode("div", {
                                class: "colect-content",
                                onClick: _withModifiers(($event: any) => (handleCollect(subItem)), ["stop"])
                              }, [
                                (_openBlock(), _createElementBlock("i", {
                                  key: subItem.menuId,
                                  class: _normalizeClass(['iconfont', subItem.collect ? 'el-icon-star-on' : 'el-icon-star-off'])
                                }, null, 2))
                              ], 8, _hoisted_17)
                            ], 8, _hoisted_15))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]))
                }), 128))
              ]))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})